import { useState, useCallback, useEffect } from 'react'
import { reduce, map, always, assoc, has, all, equals, values } from 'ramda'


type Selection = Record<string, boolean>
export const defaultSelection = {} as Selection

export function useSelection() {
  const [selection, setSelection] = useState(defaultSelection)
  const [allSelected, setAllSelected] = useState<boolean>(false)
  const [invalidate, setInvalidate] = useState<boolean>(false)

  useEffect(() => {
    if (invalidate) {
      setInvalidate(false)
      setAllSelected(all(equals(true), values(selection)))
    }
  }, [invalidate, selection])

  const handleInit = useCallback((idItems: Array<string>) => {
    setSelection(reduce((acc, val) => {
      acc[String(val)] = false
      return acc
    }, {}, idItems))
    setAllSelected(false)
  }, [])

  const handleUpdate = useCallback((id: string, selected: boolean) => {
    setSelection((prev) => {
      if (has(id, prev)) {
        return assoc(id, selected, prev)
      }
      return prev
    })
    if (allSelected) {
      setAllSelected(selected)
      return
    }
    setInvalidate(true)
  }, [allSelected])

  const handleUpdateAll = useCallback((isSelectedAll: boolean) => {
    setSelection(prevSelection => map(always(isSelectedAll), prevSelection))
    setAllSelected(isSelectedAll)
  }, [])

  return {
    selection,
    allSelected,
    init: handleInit,
    update: handleUpdate,
    updateAll: handleUpdateAll,
  } as const
}
